import AspApi from "api/ApiConfig";

export const fetchConversationSummary = async (brandId, startDate, endDate) => {
  return AspApi.get(
    `/api/v1/svc/whatsapp/conversations/conversation_summary?brand_id=${brandId}&start_date=${startDate}&end_date=${endDate}`
  );
};

export const fetchBusinessInsights = async (
  brandId,
  startEpoch,
  endEpoch,
  fields = []
) => {
  let url = `/api/v1/svc/whatsapp/business_insights?brand_id=${brandId}&start_date=${startEpoch}&end_date=${endEpoch}`;
  if (fields.length > 0) {
    fields.forEach((field) => {
      url += `&fields[]=${field}`;
    });
  }
  return AspApi.get(url);
};

export const whatsappBusinessNumbers = async (brandId, params) => {
  const qpm = [`brand_id=${params?.brand_id}`];
  if (params?.call_meta === "false") qpm.push(`call_meta=${params?.call_meta}`);

  const qpmString = qpm.length > 0 ? `?${qpm.join("&")}` : "";
  return AspApi.get(`/api/v1/svc/whatsapp/whatsapp_numbers${qpmString}`);
};

export const fetchNeedsAttentionAlerts = async (brandId) => {
  return AspApi.get(
    `/api/v1/brands/${brandId}/needs_attention_alerts?brand_id=${brandId}`
  );
};
